var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meta)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.meta.color,"small":_vm.small}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.meta.icon))])]}}],null,false,1994876233)},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.meta.key)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }